import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MarqueeRibbon from "@/components/MarqueeRibbon";
import Chapters from "@/components/Chapters";
import Gallery from "@/components/Gallery";
import BuildSheet from "@/components/BuildSheet";
import Details from "@/components/Details";
import Extras from "@/components/Extras";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-background text-foreground font-body" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Chapters />
        <Gallery />
        <BuildSheet />
        <Details />
        <Extras />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
